export const originDomain = () => {
  return useRuntimeConfig().public.originDomain;
};

export const withDebugBuild = () => {
  return useRuntimeConfig().public.withDebugBuild;
};

export const buildUniqueId = () => {
  return useRuntimeConfig().public.BUILD_UNIQUE_ID;
};

export const logInfoRequest = (): string => {
  const buildId = useRuntimeConfig().public.BUILD_UNIQUE_ID;
  // @ts-ignore
  const current = new Date() * 1;

  return '1-' + current + '-' + buildId;
};

export const currentLocale = () => {
  return 'pt-br';
};

export const isDev = () => {
  return !!(
    useRuntimeConfig().public.nodeEnv !== 'production' ||
    useRuntimeConfig().public.nodeDebug === true
  );
};

export const isStage = () => {
  return !!useRuntimeConfig().public.originDomain.includes('stage');
};

export function getLogRequestHeaderValue() {
  try {
    return logInfoRequest();
  } catch (ex) {
    return `1-${+new Date()}-nobuild`;
  }
}
